export default "__VITE_ASSET__21ad78bc__"